/**
 * @format
 */

import React, { useState } from 'react';
import { NavLink } from 'react-router-dom';
import { useAuth } from '../hooks/useAuth';
import { SignInCredentials } from '../types/auth.types';

const LoginFormContainer: React.FC = () => {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const { signIn, error, clearError } = useAuth();

  const handleSubmit = async (event: React.FormEvent<HTMLFormElement>) => {
    event.preventDefault();
    clearError();

    const credentials: SignInCredentials = { username, password };
    
    try {
      await signIn(credentials);
      // Redirect to new app after successful login
      window.location.href = 'https://www.app.siadash.com/';
    } catch (error) {
      // Error is handled in the hook and displayed via Redux state
      console.error('Sign in failed:', error);
    }
  };

  return (
    <div className='signin-form-container'>
      <h2>Sign In</h2>
      <form onSubmit={handleSubmit} className='signin-form-wrapper'>
        <input
          type='text'
          value={username}
          onChange={(e) => setUsername(e.target.value)}
          placeholder='Username'
        />
        <input
          type='password'
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          placeholder='Password'
        />
        {error && <div style={{ color: 'red' }}>{error}</div>}
        <button type='submit'>Login</button>
      </form>
      <div>
        <span>Forgot your password? reset it</span>
        <span>
          {' '}
          <NavLink to='/reset-password'>here</NavLink>{' '}
        </span>
      </div>
    </div>
  );
};

export default LoginFormContainer;
